import React from 'react';

function Donations() {
  const items = [
    { icon: '🍖', title: 'Cibo per cani' },
    { icon: '🛏️', title: 'Cucce e coperte' },
    { icon: '💊', title: 'Medicine' },
    { icon: '🎾', title: 'Giochi' },
    { icon: '🧽', title: 'Prodotti pulizia' },
    { icon: '💶', title: 'Contributo' },
  ];

  return (
    <section className="section container donations" id="donazioni">
      <h2 className="section-title">Come puoi aiutarci</h2>
      <p className="section-subtitle">Non puoi adottare? Non preoccuparti, ci sono tanti modi per sostenere il canile e i nostri cuccioli!</p>
      
      <div className="donations-grid animate-on-scroll">
        {items.map((item, index) => (
          <div className="donation-item" key={index}>
            <div className="donation-icon">{item.icon}</div>
            <h4>{item.title}</h4>
          </div>
        ))}
      </div>
      
      <div className="donation-btns animate-on-scroll">
        <button className="btn btn-primary" style={{ backgroundColor: 'var(--color-primary-dark)' }}>Dona ora</button>
        <button className="btn btn-outline">Scopri cosa serve</button>
        <button className="btn btn-outline">Aiutaci con beni materiali</button>
      </div>
    </section>
  );
}

export default Donations;
